angular.module('CarsSaraBo').config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when("/company/:companyOid/contract", {
        templateUrl: 'templates/contract/index.html',
        controller: 'ContractsController',
        title: 'contract.TITLE',
        sidebar: 'company'
    });

    $routeProvider.when("/company/:companyOid/contract/:oid", {
        templateUrl: 'templates/contract/edit.html',
        controller: 'ContractController',
        title: 'contract.TITLE',
        sidebar: 'company'
    });

    $routeProvider.when("/company/:companyOid/contract/:oid/viewTerm/:legalDocumentOid", {
        templateUrl: 'templates/contract/viewTermAndConditions.html',
        controller: 'TermAndConditionsController',
        title: 'contract.TITLE',
        sidebar: 'company'
    });



}]);



//////////////////
// WEBPACK FOOTER
// ./public/app/contract/contract_route.js
// module id = 919
// module chunks = 3